import { useAnimation, motion } from "framer-motion";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const TeamCard = ({ source, name, title, twitter }) => {
  const viewAnim = {
    visible: {
      opacity: 1,
      transform: "translateY(0px)",
      transition: { duration: 0.4 },
    },
    hidden: {
      opacity: 0.025,
      transform: "translateY(-50px)",
      transition: { duration: 0.4 },
    },
  };

  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.25 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={viewAnim}
      className="team-card col-md"
    >
      <div className="team-card-header">
        <div className="avatar">
          <img src={source} alt="user-image" />
        </div>
        <div className="profile-name">
          <h1>{name}</h1>
          <hr
            style={{
              color: "var(--primary)",
              margin: "0px 0px 5px",
              padding: 1,
              opacity: 0.6,
              borderRadius: 5,
            }}
          />
        </div>
        <div className="profile-role">{title}</div>
      </div>
      <div style={{ padding: "20px 0px" }}>
        <div className="social-buttons">
          <button>
            <a href={twitter} rel="noreferrer" target="_blank">
              <i className="fab fa-twitter"></i>
            </a>
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default TeamCard;
